jQuery(function () {
  var password_filed = 'input[name="customer[password]"]';
  var password_error_message = "Ditt lösenord måste innehålla 6 tecken och minst 1 siffra";

  $(password_filed).closest('form')
    .submit(function (e) {
      var password = $(this).find(password_filed).val();
      var is_match = password.match(/^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/);
      var has_errors = false;
      if(!is_match){
        e.preventDefault();
        has_errors = true;
      }
      $error_list_wrapper = $(this).find(".account-message.message--error");
      $error_list = $error_list_wrapper.find("ul");
      $error_list.find("li[id='password-error']").remove();
        if(has_errors){
          if($error_list && $error_list.length > 0){
              $error_list.append("<li id='password-error'>" + password_error_message + "</li>");
          } else {
              $(this).prepend("<div class='account-message message--error'><ul><li id='password-error'>" + password_error_message + "</li></ul></div>");
          }
        }
       if($error_list_wrapper.find('li').length == 0){
         $error_list_wrapper.remove();
       }
    });
});
